import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DashboardModel } from '../../models/dashboard.model';
import { TutorialService } from '../../services/tutorial.service';

@Component({
    selector: 'app-payment-method-required',
    templateUrl: './payment-method-required.component.html',
    styleUrls: ['./payment-method-required.component.css'],
    standalone: false
})
export class PaymentMethodRequiredComponent implements OnInit, AfterViewInit {

  public dashboard_model: DashboardModel;

  constructor(private route: ActivatedRoute, private tutorial_service: TutorialService) {
  }

  ngOnInit() {
    this.route.data.subscribe(({ dashboard_model }) => {
      this.dashboard_model = dashboard_model;
    });
  }

  ngAfterViewInit() {
    this.tutorial_service.openTutorial(this.dashboard_model.group?.property?.market?.resident_portal_tutorial_url, this.dashboard_model.customer);
  }
}
